import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Dropdown,
  Image,
  Row,
  Tab,
  Nav,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import RequestPayoutModal from "./RequestPayoutModal";
import { useDispatch, useSelector } from "react-redux";
import { userWalletStart, withdrawalListStart } from "../../store/slices/WithdrawSlice";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Field, Form as FORM, Formik } from "formik";
import NoDataFound from "../Helper/NoDataFound";
import Pagination from "../Helper/Pagination";
import SettlementCancelModal from "./SettlementCancelModal";
import { useTranslation } from "react-multi-lang";
import { DASH_TOTAL_SETTLE } from "../Helper/SVG";
import ViewSettlementModal from "./ViewSettlementModal";
import StatusBadge from "./StatusBadge";
import { display } from "../Utility/Utility";

const SettlementIndex = (props) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const t = useTranslation("settlement");
  const [modalShow, setModalShow] = React.useState(false)
  const [searchParams] = useSearchParams();
  const withdrawalList = useSelector(state => state.withdraw.withdrawalList);
  const userWallet = useSelector(state => state.withdraw.userWallet);
  const profile = useSelector(state => state.admin.profile);
  const [requestPayout, setRequestPayout] = useState(false);
  const [skipRender, setSkipRender] = useState(true);
  const [filter, setFilter] = useState({
    search_key: searchParams.get("search_key")
      ? searchParams.get("search_key")
      : "",
    status: "",
  });
  const [page, setPage] = useState(
    searchParams.get("page") ? searchParams.get("page") : 1
  );
  const [settlementCancelModal, setSettlementCancelModal] = useState(false);

  const closeSettlementCancelModal = () => {
    setSettlementCancelModal(false);
  };


  const closeRequestPayoutModal = () => {
    setRequestPayout(false);
  };

  useEffect(() => {
    if (!profile.loading && Object.keys(profile.data).length > 0) {
      dispatch(userWalletStart());
    }
  }, []);

  useEffect(() => {
    if (!profile.loading && Object.keys(profile.data).length > 0) {
      dispatch(
        withdrawalListStart({
          ...filter,
          skip: 12 * (page - 1),
          take: 12,
        })
      );
    }
  }, [profile, filter, page]);


  const handlePageClick = ({ selected }) => {
    let params = searchParams.get("search_key")
      ? `search_key=${searchParams.get("search_key")}&`
      : "";
    navigate(`/settlement?${params}page=${selected + 1}`);
  };

  useEffect(() => {
    if (!skipRender) {
      setPage(searchParams.get("page") ? searchParams.get("page") : 1);
      setFilter({
        search_key: searchParams.get("search_key")
          ? searchParams.get("search_key")
          : "",
      });
    }
    setSkipRender(false);
  }, [searchParams.get("page"), searchParams.get("search_key")]);

  useEffect(() => {
    if (!skipRender) {
      setPage(searchParams.get("page") ? searchParams.get("page") : 1);
    }
    setSkipRender(false);
  }, [searchParams.get("page")]);

  return (
    <>
      <div className="settlement-sec">
        <div className="settlement-top-sec">
          <h3>{t("heading")}</h3>
          <Button
            type="button"
            className="snapgopay-payment-btn"
            onClick={() => setRequestPayout(true)}
            disabled={
              userWallet.loading ||
              !Object.keys(userWallet.data).length > 0 ||
              parseInt(userWallet.data.user_wallet.remaining.slice(2)) <= 0
            }
          >
            {t("request_settlement")}
          </Button>
        </div>
        <div className="settlement-header-sec">
          <div className="settlement-header-box">
            {userWallet.loading ? (
              [...Array(3)].map((i, key) => <Skeleton key={key} height={100} />)
            ) : Object.keys(userWallet.data).length > 0 &&
              Object.keys(userWallet.data.user_wallet).length > 0 ? (
              <React.Fragment>
                <div className="dash-card_grid">
                  <div className="dashboard-card_one">
                    <div>{t("total_settlement_amount")}</div>
                    <div>{userWallet.data.user_wallet.total}</div>
                  </div>
                  <div className="dashboard-card_icons">
                    <DASH_TOTAL_SETTLE />
                  </div>
                </div>
                <div className="dash-card_grid">
                  <div className="dashboard-card_one">
                    <div>{t("available_withdrawal_amount")}</div>
                    <div>{userWallet.data.user_wallet.remaining}</div>
                  </div>
                  <div className="dashboard-card_icons">
                    <DASH_TOTAL_SETTLE />
                  </div>
                </div>
                <div className="dash-card_grid">
                  <div className="dashboard-card_one">
                    <div>{t("minimum_withdrawal_amount")}</div>
                    <div> {userWallet.data.user_wallet.mininum_withdrawal_amount}</div>
                  </div>
                  <div className="dashboard-card_icons">
                    <DASH_TOTAL_SETTLE />
                  </div>
                </div>
                {/* 
                 <div className="dash-card_grid">
                      <div className="dashboard-card_one">
                          <div>{t("rolling_reserve_remaining")}</div>
                    <div>{userWallet.data.user_wallet.rolling_reserve_remaining}</div>
                      </div>
                      <div className="dashboard-card_icons">
                        <DASH_TOTAL_SETTLE />
                      </div>
                    </div>*/
                }

              </React.Fragment>
            ) : null}
          </div>
        </div>
        <div className="settlement-body-sec">
          <div className="settlement-title-sec">
            <h3>{t("settlement_history")}</h3>
            <div className="header-search">
              <Formik
                initialValues={{
                  search_key: searchParams.get("search_key")
                    ? searchParams.get("search_key")
                    : "",
                }}
                onSubmit={(val) => {
                  setFilter({
                    ...filter,
                    search_key: val.search_key,
                  });
                  navigate(`/settlement?search_key=${val.search_key}`);
                }}
              >
                {({ values, setFieldValue, resetForm }) => (
                  <FORM className="form">
                    <InputGroup className="mb-0">
                      <Field
                        placeholder="Search"
                        type="text"
                        className="form-control"
                        name="search_key"
                      />
                      <InputGroup.Text id="basic-addon2">
                        {searchParams.get("search_key") && (
                          <button
                            type="button"
                            className="search-btn"
                            onClick={() => {
                              setFieldValue("search_key", "");
                              setFilter({
                                ...filter,
                                search_key: "",
                              });
                              navigate(`/settlement`);
                            }}
                          >
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="#3E4351"
                              data-name="Layer 1"
                              viewBox="0 0 24 24"
                            >
                              <path d="M16.707 8.707L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293-1.414-1.414L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414zM24 12c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12zm-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10 10-4.486 10-10z"></path>
                            </svg> */}
                            <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                          </button>
                        )}
                      </InputGroup.Text>
                      <InputGroup.Text id="basic-addon2">
                        <button className="search-btn" type="submit">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="#3E4351"
                            x="0"
                            y="0"
                            enableBackground="new 0 0 513.749 513.749"
                            version="1.1"
                            viewBox="0 0 513.749 513.749"
                            xmlSpace="preserve"
                          >
                            <path d="M504.352 459.061l-99.435-99.477c74.402-99.427 54.115-240.344-45.312-314.746S119.261-9.277 44.859 90.15-9.256 330.494 90.171 404.896c79.868 59.766 189.565 59.766 269.434 0l99.477 99.477c12.501 12.501 32.769 12.501 45.269 0 12.501-12.501 12.501-32.769 0-45.269l.001-.043zm-278.635-73.365c-88.366 0-160-71.634-160-160s71.634-160 160-160 160 71.634 160 160c-.094 88.326-71.673 159.906-160 160z"></path>
                          </svg>
                        </button>
                      </InputGroup.Text>
                    </InputGroup>
                  </FORM>
                )}
              </Formik>
            </div>
          </div>
          <div className="settlement-tab-sec">
            <Tab.Container id="left-tabs-example" defaultActiveKey="all">
              <Row>
                <Col sm={12}>
                  {userWallet.loading ? (
                    <div className="nav-pills-skeleton">
                      {[...Array(5)].map((i, key) => (
                        <Skeleton key={key} height={40} />
                      ))}
                    </div>
                  ) : Object.keys(userWallet.data).length > 0 &&
                    Object.keys(userWallet.data.user_withdrawals).length > 0 ? (
                    <Nav variant="pills">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="all"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: "",
                            });
                          }}
                          active={filter.status === ""}
                        >
                          {t("all")}{" "}
                          <span>{userWallet.data.user_withdrawals.total}</span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="all"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: 0,
                            });
                          }}
                          active={filter.status === 0}
                        >
                          {t("initiated")}{" "}
                          <span>
                            {userWallet.data.user_withdrawals.initiated}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="pending"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: 1,
                            });
                          }}
                          active={filter.status == 1}
                        >
                          {t("paid")}{" "}
                          <span>{userWallet.data.user_withdrawals.paid}</span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="all"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: 2,
                            });
                          }}
                          active={filter.status == 2}
                        >
                          {t("onhold")}{" "}
                          <span>{userWallet.data.user_withdrawals.onhold}</span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="pending"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: 3,
                            });
                          }}
                          active={filter.status == 3}
                        >
                          {t("rejected")}{" "}
                          <span>
                            {userWallet.data.user_withdrawals.rejected}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="all"
                          onClick={() => {
                            setFilter({
                              ...filter,
                              status: 4,
                            });
                          }}
                          active={filter.status == 4}
                        >
                          {t("cancelled")}{" "}
                          <span>
                            {userWallet.data.user_withdrawals.cancelled}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  ) : null}
                  <div className="settlement-search-sec"></div>
                </Col>
                <Col sm={12}>
                  <div className="settlement-tab-content">
                    <div className="settlement-table-sec table-responsive">
                      {withdrawalList.loading ? (
                        [...Array(3)].map((i, key) => (
                          <Skeleton key={key} height={50} />
                        ))
                      ) : Object.keys(withdrawalList.data).length > 0 ? (
                        <React.Fragment>
                          <Table>
                            <thead>
                              <tr>
                                <th>{t("settlement_table.si_no")}</th>
                                <th>{t("settlement_table.payment_id")}</th>
                                <th>{t("settlement_table.amount")}</th>
                                <th>{t("settlement_table.mode")}</th>
                                <th>{t("settlement_table.requested_date")}</th>
                                <th>{t("settlement_table.status")}</th>
                                <th>{t("settlement_table.actions")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {withdrawalList.data.user_withdrawals.length >
                                0 ? (
                                withdrawalList.data.user_withdrawals.map(
                                  (withdrawal, i) => (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{display(withdrawal.unique_id)}</td>
                                      <td>{display(withdrawal.amount)}</td>
                                      <td>{display(withdrawal.type_formatted)}</td>
                                      <td>{display(withdrawal.created_at)}</td>
                                      <td>
                                        <div className="settlement-status-cell">
                                          <StatusBadge status={withdrawal.status_formatted} />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="payment-link-dropdown">
                                          <Dropdown>
                                            <div className="payment-link-icon-sec">
                                              <Dropdown.Toggle id="dropdown-basic">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="20"
                                                  height="20"
                                                  x="0"
                                                  y="0"
                                                  enableBackground="new 0 0 512 512"
                                                  version="1.1"
                                                  viewBox="0 0 512 512"
                                                  xmlSpace="preserve"
                                                >
                                                  <circle
                                                    cx="458.667"
                                                    cy="256"
                                                    r="53.333"
                                                  ></circle>
                                                  <circle
                                                    cx="256"
                                                    cy="256"
                                                    r="53.333"
                                                  ></circle>
                                                  <circle
                                                    cx="53.333"
                                                    cy="256"
                                                    r="53.333"
                                                  ></circle>
                                                </svg>
                                              </Dropdown.Toggle>
                                            </div>
                                            <Dropdown.Menu>
                                              <Dropdown.Item onClick={() => setModalShow(withdrawal)} >
                                                <span>{t("view_btn")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div>
                                      </td>
                                      {/* <td>
                                      {withdrawal.status === 0 ? <OverlayTrigger
                                          placement="top"
                                          trigger="hover"
                                          overlay={
                                            <Tooltip id="tooltip">
                                              <strong>{t("cancel_settlement")}</strong>{" "}
                                            </Tooltip>
                                          }
                                        >
                                          <button className="cancel-settlement-btn" onClick={() => setSettlementCancelModal(withdrawal.id)}>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="#FF6A6A"
                                              viewBox="0 0 24 24"
                                              stroke-width="1.5"
                                              stroke="currentColor"
                                              class="w-6 h-6"
                                            >
                                              <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12"
                                              />
                                            </svg>
                                          </button>
                                        </OverlayTrigger> : null}
                                      </td> */}
                                    </tr>
                                  )
                                )
                              ) : (
                                <td colSpan="6" className="text-center">
                                  <NoDataFound />
                                </td>
                              )}
                            </tbody>
                          </Table>
                          <div className="new-billings-pagination-sec">
                            <Pagination
                              page={page}
                              handlePageClick={handlePageClick}
                              pageCount={Math.ceil(
                                withdrawalList.data.total_user_withdrawals / 12
                              )}
                            />
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      </div>
      {requestPayout && (
        <RequestPayoutModal
          wallet={userWallet.data.user_wallet}
          requestPayout={requestPayout}
          closeRequestPayoutModal={closeRequestPayoutModal}
          setRequestPayout={setRequestPayout}
        />
      )}
      {settlementCancelModal && (
        <SettlementCancelModal
          settlementCancelModal={settlementCancelModal}
          closeSettlementCancelModal={closeSettlementCancelModal}
          setSettlementCancelModal={setSettlementCancelModal}
        />
      )}
      {modalShow && <ViewSettlementModal
        settlement={modalShow}
        onHide={() => setModalShow(false)}
      />}
    </>
  );
};

export default SettlementIndex;
